import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus } from "@/state";


const platformAlertsQuery = gql`
  query platformAlerts{
    platformAlerts
    {
      id
      message
     
    }
  }
`;

export function useSystemActions() {

    const [apiGetPlatformAlerts] = useLazyQuery(platformAlertsQuery);


    function GetPlatformAlerts() {

        return new Promise(async (resolve, reject) => {

            try {
                apiGetPlatformAlerts()
                .then((result: any) => result?.data?.platformAlerts)
                .then((result) => resolve(result))
                .catch((err) => {
                    let data =  JSON.parse(JSON.stringify(err))
                    if(data?.message?.includes("user is not authorized"))
                    {
                        eventBus.next({type: AuthorizationCheckRequired})
                    }

                    if (err.name === 'AbortError') {
                        // Handle aborted request gracefully
                        return;
                      }
    
                    toast.error("Api Error, Unable to get platform alerts!");
                    reject(err);
                })
            }
            catch {
                reject("Api Error");
            }

            
        })
    }

    
    return {
        GetPlatformAlerts,
        
        // GetApplicationStatuses: (orgId) => GetLookupGroupValues(orgId, "application_status")

    };
}




